import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {ToastModule} from 'primeng/toast';
import {BlockUIModule} from 'primeng/blockui'

import { ConnectConfigurationComponent } from './connect-configuration/connect-configuration.component';
import { PrimengModule } from './../global/primeng.module';
import { EditConfigurationComponent } from './connect-configuration/edit-configuration/edit-configuration.component';
import { ViewConfigurationTypeComponent } from './connect-configuration/view-configuration-type/view-configuration-type.component';

@NgModule({
  declarations: [
    ConnectConfigurationComponent,
    EditConfigurationComponent,
    ViewConfigurationTypeComponent
  ],
  imports: [
    CommonModule,
    BlockUIModule,
    PrimengModule,
    ToastModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [ConnectConfigurationComponent]
})
export class SettingModule { }
